import './cancel-trade-via-rfq.scss'

import { notification, Popconfirm } from 'antd'
import axios from 'axios'
import { Formik, FormikHelpers } from 'formik'
import { Form, FormItem, Input, SubmitButton } from 'formik-antd'
import React from 'react'
import { Column, Row } from 'react-display-flex'

import { parseApiErrorResponse } from '../../../components/forms/utils'
import { momentDateHandler } from '../../../date/moment-date-handler'
import { formatCurrency } from '../../../formatters'
import { messages } from '../messages'
import { Rfq, RollbackRfqFormValues } from '../models'
import { validationSchema } from './validation'

const { newDate, formatDate } = momentDateHandler
const initialValues: RollbackRfqFormValues = { reason: '' }

interface Props {
  rfq: Rfq
  onSubmitSuccess: () => void
}

export const CancelTradeViaRfq = ({ rfq, onSubmitSuccess: mutate }: Props) => {
  const onSubmit = async ({ reason }: RollbackRfqFormValues, { setErrors }: FormikHelpers<RollbackRfqFormValues>) => {
    try {
      await axios.put(`/rfqs/${rfq.uuid}/rollback`, { reason })

      notification.success({ message: 'Success', description: messages.rollbackRfq.success })
      mutate()
    } catch (error) {
      setErrors(parseApiErrorResponse(error))

      notification.error({ message: 'Error', description: messages.rollbackRfq.error })
    }
  }

  return (
    <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
      {({ submitForm }) => (
        <Form name="rollback-rfq" className="rollback-rfq" layout="horizontal">
          <Row justifyContentSpaceBetween>
            <div>
              <dt>Tenant</dt>
              <dd>{rfq.tenantName}</dd>
            </div>
            <div>
              <dt>Date</dt>
              <dd>{formatDate({ date: newDate(rfq.requestedAt) })}</dd>
            </div>
            <div>
              <dt>Principal ($)</dt>
              <dd>{formatCurrency({ value: rfq.principal })}</dd>
            </div>
            <div>
              <dt>Request By</dt>
              <dd>
                <a href={`mailto:${rfq.requestedBy}`}>{rfq.requestedBy}</a>
              </dd>
            </div>
          </Row>

          <FormItem name="reason" label="Rollback reason" required>
            <Input name="reason" placeholder="The main reason why it should be rolled back" />
          </FormItem>

          <FormItem name="actions">
            <Column>
              <Popconfirm
                title="Are you sure that you want to proceed? This action will cancel the RFQ and delete the trade from the investor portfolio. It cannot be reverted"
                onConfirm={submitForm}
              >
                <SubmitButton htmlType="submit" type="primary">
                  Rollback RFQ
                </SubmitButton>
              </Popconfirm>
            </Column>
          </FormItem>
        </Form>
      )}
    </Formik>
  )
}
